export enum ViewType {
  NameView,
  JoinView,
}

export interface ICallInvitationPresenter {
  setView: (view: ViewType) => void;
  currentView: ViewType;
}

export type ISetView = ICallInvitationPresenter['setView'];
